export function timezoneOffset(time: Date) {
  const offsetTime = new Date(time);
  const diff = (offsetTime.getTimezoneOffset() / 60) * -1; // convert to positive value.
  offsetTime.setTime(offsetTime.getTime() + diff * 60 * 60 * 1000);

  return offsetTime;
}
